import { StandardEvents } from '@shopify/events';

const visibleCartAnchor = element => {
  if (!element?.isConnected) return null;
  const rect = element.getBoundingClientRect();
  if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= innerHeight || rect.right <= 0 || rect.left >= innerWidth) return null;
  return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
};

const flyBagToCart = source => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const destination = Array.from(document.querySelectorAll('cart-icon.header-actions__cart-icon > .svg-wrapper'))
    .find(element => visibleCartAnchor(element));
  const start = visibleCartAnchor(source);
  const end = visibleCartAnchor(destination);
  const icon = source?.closest('.om-card-bag') ? source : destination?.querySelector('svg');
  if (!start || !end || !icon) return;

  const flight = document.createElement('div');
  flight.className = 'ochre-cart-flight';
  flight.setAttribute('aria-hidden', 'true');
  flight.style.left = `${start.x - 12}px`;
  flight.style.top = `${start.y - 12}px`;
  flight.appendChild(icon.cloneNode(true));
  document.body.appendChild(flight);

  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const lift = Math.min(110, Math.max(40, Math.abs(dy) * 0.18));
  const frames = Array.from({ length: 21 }, (_, index) => {
    const progress = index / 20;
    const x = dx * progress;
    const y = dy * progress - 4 * lift * progress * (1 - progress);
    return {
      offset: progress,
      transform: `translate(${x}px, ${y}px) rotate(${-12 * Math.sin(Math.PI * progress)}deg) scale(${1 - progress * 0.35})`,
      opacity: progress < 0.85 ? 1 : (1 - progress) / 0.15,
    };
  });
  flight.animate(frames, { duration: 760, easing: 'cubic-bezier(.22,.61,.36,1)' })
    .finished.then(() => flight.remove(), () => flight.remove());
};

document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  if (event.action !== 'add' || !event.promise) return;
  const form = event.target instanceof Element ? event.target.closest('product-form-component') : null;
  if (!form) return;
  const quickAdd = form.closest('#quick-add-dialog');
  const source = quickAdd
    ? document.querySelector('.om-card-bag[stay-visible] .om-card-bag__button svg')
    : form.querySelector('button[name="add"] .add-to-cart-icon svg') || form.querySelector('button[name="add"]');

  event.promise.then(({ cart, detail }) => {
    if (!cart || detail?.didError) return;
    const launch = () => requestAnimationFrame(() => flyBagToCart(source));
    if (quickAdd?.querySelector('dialog[open]')) {
      quickAdd.addEventListener('dialog:close', launch, { once: true });
    } else {
      launch();
    }
  }).catch(() => {});
});

const controls = new Set();
const observer = new IntersectionObserver(entries => {
  for (const entry of entries) {
    if (entry.isIntersecting) controls.add(entry.target);
    else controls.delete(entry.target);
  }
  for (const item of controls) if (!item.isConnected) controls.delete(item);
  document.body.classList.toggle('ochre-purchase-visible', controls.size > 0);
}, { threshold: 0 });
const scan = root => root.querySelectorAll('.variant-picker, .product-form-buttons').forEach(element => observer.observe(element));
scan(document);
document.addEventListener('shopify:section:load', event => scan(event.target));

  if (!customElements.get('ochre-measure-guide')) {
    customElements.define('ochre-measure-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-measure-open]');
        this.trigger.addEventListener('click', () => {
          this.dialog.showModal();
          this.trigger.setAttribute('aria-expanded', 'true');
          this.querySelector('.om-close').focus({ preventScroll: true });
        });
        this.querySelectorAll('[data-measure-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          this.trigger.setAttribute('aria-expanded', 'false');
          if (this.isConnected) this.trigger.focus({ preventScroll: true });
        });
      }
    });
  }
